import cx from "classnames";
import { useRef, useState } from "react";

import { isNullish, useEventListener } from "@theorgchartdev/storybook";
import { useTopic } from "@/hooks/useTopic";
import { GetWSMgr } from "@/Utils/StateLib";

function doesEventIntersect(event, element) {
  const rect = element.getBoundingClientRect();

  return (
    event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom
  );
}

/**
 * type Props = {
 *   children: ReactNode;
 *   className?: string;
 *   onDragEnd?: (panel) => void;
 * }
 */
export const DropArea = props => {
  const containerRef = useRef(null);
  const panelRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [isOver, setIsOver] = useState(false);

  const wsMgr = GetWSMgr();

  useTopic("dragStart", ({ panel }) => {
    setIsDragging(true);
    setIsOver(false);

    panelRef.current = panel;
  });

  useEventListener(
    "mouseup",
    event => {
      setIsDragging(false);
      if (!panelRef.current) {
        return;
      }

      const intersects = doesEventIntersect(event, containerRef.current);
      if (!intersects) {
        panelRef.current = null;
        return;
      }

      const panel = panelRef.current;
      panelRef.current = null;

      props?.onDragEnd(panel);
    },
    { enabled: isDragging, eventOptions: true }
  );

  useEventListener(
    "mousemove",
    event => {
      const intersects = doesEventIntersect(event, containerRef.current);
      setIsOver(intersects);

      wsMgr.BroadcastTopic("dragBoxValidDropAreaTarget", { validHit: intersects });
    },
    { enabled: isDragging }
  );

  return (
    <div
      ref={containerRef}
      {...props}
      className={cx(props.className, {
        "oc-drop-area--active": isDragging && isOver
      })}
    >
      {props.children}
    </div>
  );
};
